// Paramètres du notaire (page Réglages + page Infos utilisateur, voir pages/settingsPage.ts et
// pages/userInfoPage.ts -- elles sauvegardent chacune un sous-ensemble de champs sans s'écraser).
import { getPraetoriaApiToken, PRAETORIA_API_BASE_URL } from "../config";
import { buildApiError } from "./errors";

export interface NotarySettings {
  consignes_constantes?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  fonction?: string;
  genre?: string;
  nom_office?: string;
  adresse_cabinet?: string;
}

// Mise à jour partielle : seules les clés présentes dans `settings` sont envoyées, donc
// écrites côté serveur (merge, pas de remplacement complet) -- la page "Paramètres" et la
// page "Informations utilisateur" peuvent sauvegarder indépendamment sans s'écraser.
export async function saveSettings(graphToken: string, settings: NotarySettings): Promise<NotarySettings> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/settings`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ graph_access_token: graphToken, ...settings }),
  });

  if (!response.ok) {
    throw await buildApiError(response);
  }

  return await response.json();
}

export async function getSettings(graphToken: string): Promise<NotarySettings> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/settings/get`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ graph_access_token: graphToken }),
  });

  if (!response.ok) {
    throw await buildApiError(response);
  }

  return await response.json();
}
